export enum FuelTypeGrouping {
  lowCarbon = "Low Carbon",
  fossilFuel = "Fossil Fuels",
  other = "Other",
  interconnector = "Interconnectors",
}
